var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('blockquote',{staticClass:"pl-4",staticStyle:{"border-left":"4px solid"},style:({ 'border-color': _vm.primaryColor })},[_c('p',{staticClass:"font-weight-medium text-h6"},[_vm._v(_vm._s(_vm.textBlockQuote))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }